import { Modal } from '@/components/Modal';
import { Folder, Filter } from 'lucide-react';
import { Button } from '@/components/Button';
import { useNavigate } from 'react-router-dom';

interface ModelCollectionsModalProps {
  open: boolean;
  onClose: () => void;
  modelName: string;
  collections: Array<{
    id: string;
    collection: {
      id: string;
      name: string;
      color: string | null;
    };
  }>;
}

export function ModelCollectionsModal({
  open,
  onClose,
  modelName,
  collections,
}: ModelCollectionsModalProps) {
  const navigate = useNavigate();

  const handleFilterByCollection = (collectionId: string) => {
    // Navigate to models page with collection filter
    navigate(`/models?collection=${collectionId}`);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title={`Collections - ${modelName}`} size="lg">
      <div className="space-y-4">
        {collections.length === 0 ? (
          <div className="text-center py-8 text-foreground-muted">
            <Folder className="h-12 w-12 mx-auto mb-3 opacity-50" />
            <p>This model is not in any collections</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border text-left">
                  <th className="pb-3 pr-4 text-sm font-medium text-foreground-muted">Collection</th>
                  <th className="pb-3 text-sm font-medium text-foreground-muted">Actions</th>
                </tr>
              </thead>
              <tbody>
                {collections.map((mc) => (
                  <tr key={mc.id} className="border-b border-border last:border-0">
                    <td className="py-3 pr-4">
                      <div className="flex items-center gap-2">
                        <Folder
                          className="h-4 w-4 flex-shrink-0"
                          style={{ color: mc.collection.color || '#6b7280' }}
                        />
                        <span className="text-sm text-foreground">{mc.collection.name}</span>
                      </div>
                    </td>
                    <td className="py-3">
                      <Button
                        variant="ghost"
                        size="sm"
                        leftIcon={<Filter className="h-4 w-4" />}
                        onClick={() => handleFilterByCollection(mc.collection.id)}
                      >
                        Filter to Collection
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Modal>
  );
}
